
const openNewTab = (urlRel) => window.open(urlRel, '_blank');

export { openNewTab };
